// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React components
import TransparentBlogCard from "examples/Cards/BlogCards/TransparentBlogCard";
import animations_content from "content/Animations.json";

function Places() {
  return (
    <MKBox component="section" py={2}>
      <Container>
        <Grid container item xs={12} lg={6}>
          <MKTypography variant="h3" mb={6}>
            Explore our new collection of animations
          </MKTypography>
        </Grid>
        <Grid container spacing={3}>
          {animations_content.animations_showcase.map((animation, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <TransparentBlogCard
                image={animation.url}
                title={animation.title}
                description={animation.description}
                action={{
                  type: "internal",
                  route: animation.link || " ",
                  color: "info",
                  label: "Get it here",
                }}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Places;
